export default __webpack_public_path__ + "static/media/box-crossed-grey.57602353.svg";